import { TodoCounter } from './TodoCounter';
import { TodoSearch } from './TodoSearch';
import { TodoList } from './TodoList';
import { TodoItems } from './TodoItems';
import { CreateTodoBtn } from './CreateTodoBtn';
import { TodoLoading } from './TodoLoading';
import { TodoError } from './TodoError';
import { EmptyTodo } from './EmptyTodo';
import { TodoContext } from './TodoContext';
import { Form } from './Form';
import { Modal } from './Modal';
import React from 'react';
function AppUI () {
    const {
      loading,
      error, 
      searchedTodos,
      todoComplete,
      todoDelete,
      openModal,
      setOpenModal,
    } = React.useContext(TodoContext);
    return (
        <>
          <main>
            <section className='taskApp'>
              <div className='taskApp__header'>
                <h1 className='taskApp__title'>Your Task</h1>
                <TodoCounter/>
                <TodoSearch/>
              </div>
              <div className='taskApp__works'>
                <TodoList>
                {loading && <TodoLoading/>}
                {error && <TodoError/>}
                {(!loading && searchedTodos.length === 0)&& <EmptyTodo/>}
    
                {searchedTodos.map(todo => (
                  <TodoItems key = {todo.text}
                    text = {todo.text}
                    completed = {todo.completed}
                    onComplete = {()=> todoComplete(todo.text)}
                    onDelete =  {()=>todoDelete(todo.text)}
                  /> 
                ))}
                </TodoList>
              </div>
              
            </section>
            <CreateTodoBtn/>
            {openModal&&(
              <Modal>
                <Form/> 
              </Modal> 
            )}     
          </main>
          
        </>
    );
}

export { AppUI };